"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _Row = _interopRequireDefault(require("../layout/Row"));
var _Input = _interopRequireDefault(require("../atoms/Input"));
var _Form = _interopRequireDefault(require("../hocs/Form"));
var _templateObject, _templateObject2;
const _excluded = ["name", "placeholder", "sideUtilityIcon", "min", "leftIcon", "onLeftIcon", "onFocus", "onBlur", "doNotShowErrors", "onSubmit", "className", "withBorder"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var LeftIconAction = /*#__PURE__*/function (LeftIconAction) {
  LeftIconAction["Close"] = "close";
  LeftIconAction["Search"] = "search";
  LeftIconAction["Clear"] = "clear";
  return LeftIconAction;
}(LeftIconAction || {});
const defaultProps = {
  name: '',
  placeholder: '',
  sideUtilityIcon: null,
  min: 1,
  leftIcon: undefined,
  doNotShowErrors: true,
  className: '',
  withBorder: false,
  onFocus() {},
  onBlur() {},
  onSubmit() {},
  onLeftIcon() {}
};
function SearchInput(props) {
  var _colors$MAIN;
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      name,
      placeholder,
      sideUtilityIcon,
      min,
      leftIcon,
      onLeftIcon,
      onFocus,
      onBlur,
      doNotShowErrors,
      onSubmit,
      className,
      withBorder
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  const [isFocused, setIsFocused] = (0, _react.useState)(false);
  const {
    setValue,
    control
  } = _Form.default.useForm();
  const search = _Form.default.useWatch({
    control,
    name
  });
  const {
    colors
  } = (0, _react2.useTheme)();
  const hasTyped = (0, _react.useMemo)(() => (search === null || search === void 0 ? void 0 : search.length) >= min, [search, min]);
  const onKeyDown = e => {
    var _e$currentTarget, _e$currentTarget$blur;
    if (e.key !== 'Enter') return;
    onSubmit(search);
    e === null || e === void 0 || (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 || (_e$currentTarget$blur = _e$currentTarget.blur) === null || _e$currentTarget$blur === void 0 || _e$currentTarget$blur.call(_e$currentTarget);
  };
  const onPressIcon = (0, _react.useCallback)(() => {
    if (hasTyped) setValue(name, '');
    onLeftIcon === null || onLeftIcon === void 0 || onLeftIcon(hasTyped ? LeftIconAction.Clear : LeftIconAction.Search);
  }, [hasTyped, name, setValue, onLeftIcon]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    gap: 10,
    className: className
  }, /*#__PURE__*/_react.default.createElement(StyledInput, _extends({
    role: "searchbox",
    doNotShowFeedback: doNotShowErrors,
    name: name,
    onKeyDown: onKeyDown,
    icon: _objectSpread({
      position: 'left',
      name: leftIcon !== null && leftIcon !== void 0 ? leftIcon : hasTyped ? 'close' : 'search',
      size: 18,
      onClick: onPressIcon
    }, Boolean(isFocused && !hasTyped) ? {
      color: colors === null || colors === void 0 || (_colors$MAIN = colors.MAIN) === null || _colors$MAIN === void 0 ? void 0 : _colors$MAIN.INFO
    } : {}),
    withBorder: withBorder,
    placeholder: placeholder,
    onFocus: () => {
      setIsFocused(true);
      onFocus === null || onFocus === void 0 || onFocus();
    },
    onBlur: () => {
      setIsFocused(false);
      onBlur === null || onBlur === void 0 || onBlur();
    }
  }, restOfProps)), /*#__PURE__*/_react.default.isValidElement(sideUtilityIcon) && /*#__PURE__*/_react.default.cloneElement(sideUtilityIcon, {
    size: 22,
    'data-extra-icon': true
  }));
}
const Container = (0, _styled.default)(_Row.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: -10px;\n"])));
const StyledInput = (0, _styled.default)(_Input.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    input {\n      height: 50px;\n      font-size: 16px;\n    }\n  }\n"])));
var _default = exports.default = SearchInput;